export default "__VITE_ASSET__ClLqwsO6__"